var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u8BBE\u5907\u7BA1\u7406-\u9ED8\u8BA4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "065-\\u661F\\u90142.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "A16-\\u8F66\\u8F86\\u76D1\\u63A7-\\u89C6\\u9891\\u76F4\\u64AD",
    transform: "translate(-1702.000000, -22.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u8BBE\\u5907\\u7BA1\\u7406-\\u9ED8\\u8BA4",
    transform: "translate(1702.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.99944444,10.5215556 L13.9997778,10.5215556 L13.9997778,8.52188889 L1.99944444,8.52188889 L1.99944444,10.5215556 Z M13.8333333,1 L2.16666667,1 C1.52266667,1 1,1.54522222 1,2.21722222 L1,10.7393333 C1,11.4113333 1.52266667,11.9565556 2.16666667,11.9565556 L6.83333333,11.9565556 L6.83333333,13.7827778 L5.66666667,13.7827778 C5.34466667,13.7827778 5.08333333,14.055 5.08333333,14.3917778 C5.08333333,14.7277778 5.34466667,15 5.66666667,15 L10.3333333,15 C10.6553333,15 10.9166667,14.7277778 10.9166667,14.3917778 C10.9166667,14.055 10.6553333,13.7827778 10.3333333,13.7827778 L9.16666667,13.7827778 L9.16666667,11.9565556 L13.8333333,11.9565556 C14.4773333,11.9565556 15,11.4113333 15,10.7393333 L15,2.21722222 C15,1.54522222 14.4773333,1 13.8333333,1 L13.8333333,1 Z",
    id: "Fill-1"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/设备管理.9ba5e9900a2bec23c6c806690908826b.svg";
export { ForwardRef as ReactComponent };